import { formatNumber, useNavigate } from "@";

// Component for table actions
export const TableActions = (row) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/projects/create", { state: { customerCampaign: row } });
  };

  return (
    <>
      <button onClick={handleClick} className="btn-green">
        إنشاء مشروع
      </button>
    </>
  );
};

// Table columns configuration
export const tableColumns = [
  {
    name: "اسم العميل",
    selector: ({ userName }) => userName,
  },
  {
    name: "رقم الجوال",
    selector: ({ userPhone }) => userPhone,
  },
  {
    name: "عنوان المشروع",
    selector: ({ projectTitle }) => projectTitle,
  },
  {
    name: "التصنيف",
    selector: ({ classificationName }) => classificationName,
  },
  {
    name: "المبلغ المطلوب",
    selector: ({ requiredAmount }) => formatNumber(requiredAmount),
  },
];
